import { componentStyles } from "./paragraph-with-video.scss";

const ParagraphWithVideo = (props) => {
  const { title, description, videoSrc } = props;
  return (
    <div className="paragraph-with-video">
      <div className="paragraph-content-wrapper">
        <h2 className="paragraph-content-title">{title}</h2>
        <div className="paragraph-content-description">{description}</div>
      </div>
      {videoSrc && (
        <div className="paragraph-video-wrapper">
          <video className="pargraph-video-item" src={videoSrc} loop="true" muted="true" autoplay="true" />
        </div>
      )}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ParagraphWithVideo;
